/** LOGA */
export const ITERATOR_RS_LOGO_IMAGE = require("../assets/universal/img/iterators.png");
export const BOLIMOWIANKA_LOGO_IMAGE = require("../assets/universal/img/bolimowianka.png");
export const BIW_LEGAL_LOGO_IMAGE = require("../assets/universal/img/biw-legal.jpg");
export const CENTRUM_KONWERSACJI_LOGO_IMAGE = require("../assets/universal/img/centrum-konwersacji-logo.png");
export const SILENT_SL_LOGO_IMAGE = require("../assets/universal/img/silentsl.png");
export const JOANNA_INVESTMENT_LOGO_IMAGE = require("../assets/universal/img/joanna-investment.png");
export const LIME_ON_LOGO_IMAGE = require("../assets/universal/img/lime-on-logo.jpg");
export const LICYTACJE_TV_LOGO_IMAGE = require("../assets/universal/img/Logo_Licytacje.png");

/** BACKGROUNDY */
export const PIGGY_BANK_BACKGROUND_IMAGE = require("../assets/materialize-theme/img/corporate/corporate-banner-1-min.jpg");
export const BUSINESS_HANDSHAKE_BACKGROUND_IMAGE = require("../assets/universal/img/business-handshake-min.jpg");
export const BIURO_RACHUNKOWE_BACKGROUND_IMAGE = require("../assets/universal/img/biznesmen-calculator-min.jpg");
export const YACH_SAILING_BACKGROUND_IMAGE = require("../assets/universal/img/yacht-sailing-1.jpg");

/** OBRAZKI DO FICZERÓW */
export const SUITCASE_FEATURE_IMAGE = require("../assets/materialize-theme/img/business.png");
export const APPLICATION_CALCULATION_FEATURE_IMAGE = require("../assets/materialize-theme/img/data.png");
export const ANALYSIS_FEATURE_IMAGE = require("../assets/materialize-theme/img/analysis.png");
export const CONSULTING_FEATURE_IMAGE = require("../assets/universal/img/consulting.jpg");
export const SECURITY_FEATURE_IMAGE = require("../assets/universal/img/security.jpg");

/** ZDJĘCIA DO TEAMU */
export const TEAM_MEMBER_LUKASZ_IMAGE = require("../assets/universal/img/lukasz-tlo.jpg");
export const TEAM_MEMBER_MACIEK_IMAGE = require("../assets/universal/img/maciek-tlo.jpg");
export const TEAM_MEMBER_MARIUSZ_IMAGE = require("../assets/universal/img/mariusz-tlo.jpg");
export const TEAM_MEMBER_MARIUSZ_V2_IMAGE = require("../assets/universal/img/mariusz-tlo-v2.jpg");

/** LOGO */
export const FAKTUROMANIA_LOGO_AND_NAME = require("../assets/universal/img/fakturomaniaLogoAndName.png");
export const FAKTUROMANIA_LOGO_AND_NAME_STATIC_FOR_SEO = 'https://fakturomania.pl/static/fakturomaniaLogoAndName.png';
export const FAKTUROMANIA_LOGO_ICON = require("../assets/universal/img/fakturomaniaLogoIcon.png");
export const FAKTUROMANIA_LOGO_ICON_STATIC_FOR_SEO = 'https://fakturomania.pl/static/fakturomaniaLogoIcon.png';
export const FAKTUROMANIA_FAVICON_STATIC = require("../assets/universal/img/faviconFakturomania.png");
export const FAKTUROMANIA_FAVICON_STATIC_FOR_SEO = 'https://fakturomania.pl/static/faviconFakturomania.png';

/** POZOSTAŁE OBRAZKI */
export const DOTACJE_POIG_IMAGE = require("../assets/universal/img/fakturomania-dotacje.jpg");


// WEBPACK FOOTER //
// ./src/constants/static-images.ts